/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsProductSection8 = {
  init: function ($section) {
    
    // Add settings from schema to current object
    // window.PXUTheme.jsProductSection8 = $.extend(this, window.PXUTheme.getSectionData($section));

    this.element = $section[0];

    this.prevButton = this.element.querySelector("[data-carousel='previous']");
    this.nextButton = this.element.querySelector("[data-carousel='next']");

    this.initCarousel();
  },
  initCarousel() {
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new Swiper(this.carouselElement, {
      grabCursor: true,
      slidesPerView: 1.3,
      spaceBetween: 10,
      slidesOffsetAfter: 24,
      breakpoints: {
        799: {
          slidesPerView: 3.65,
          spaceBetween: 15,
          slidesOffsetAfter: 50,
        }
      },
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      on: {
        slideChange: (swiper) => {
          let prevSlide = swiper.slides[swiper.previousIndex];
          let nextSlide = swiper.slides[swiper.activeIndex];
        }
      }
    });
  }
}

/******/ })()
;